// extracted by mini-css-extract-plugin
export default {"label":"case-types__label--Id5b1","label-bold":"case-types__label-bold--JfJEE","labelBold":"case-types__label-bold--JfJEE","item":"case-types__item--eH5Rh"};